module.exports = __webpack_public_path__ + "img/screenshot-3.2f92f5d1.webp";